import has from 'lodash/has';
import { Reducer } from 'redux';

export default function createReducer<T>(
  initialState: any,
  handlers: Record<string, (state: T, action: any) => T>,
): Reducer {
  // eslint-disable-next-line @typescript-eslint/default-param-last
  return (state = initialState, action) => {
    if (has(handlers, action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}
